import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../ui/card';

type Props = {
  journeyStage?: string;
  source?: string;
  productPolicy?: string;
};

const BusinessContextCard: React.FC<Props> = ({ journeyStage, source, productPolicy }) => {
  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle>Business Context</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div>
            <div className="text-figma-xs text-figma-text-secondary uppercase tracking-wide font-medium">Journey Stage</div>
            <div className="text-figma-sm text-figma-text-primary">{journeyStage || 'Not available'}</div>
          </div>
          <div>
            <div className="text-figma-xs text-figma-text-secondary uppercase tracking-wide font-medium">Source</div>
            <div className="text-figma-sm text-figma-text-primary capitalize">{source || 'Not available'}</div>
          </div>
          <div>
            <div className="text-figma-xs text-figma-text-secondary uppercase tracking-wide font-medium">Product / Policy</div>
            <div className="text-figma-sm text-figma-text-primary">{productPolicy || 'Not available'}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default React.memo(BusinessContextCard);
